// extracted by mini-css-extract-plugin
export default {"centerAlignText":"error-boundary-fallback-container-module__centerAlignText--ni79u"};